export { default as GazCodesLogoCircleSmall } from "./GazCodesLogoCircleSmall";
export { default as GazCodesLogo } from "./GazCodesLogo";
export { default as GazCodesLogo3 } from "./GazCodesLogo3";
export { default as GazCodesLogo4 } from "./GazCodesLogo4";
export { default as GazCodesLogo4Filled } from "./GazCodesLogo4Filled";
export { default as Logo2CenteredLayered } from "./Logo2CenteredLayered";

// default
export { default as Logo } from "./GazCodesLogoCircleSmall";
